/** Safe recovery for a failed request. Never implies that a mutation was rolled back. */
export type Recovery = "sign_in" | "account" | "retry" | "refresh" | "edit" | "unavailable" | "none";
export function recoveryFor(status: number, code: string): Recovery {
  if (status === 401) return "sign_in";
  if (code === "state_conflict" || code === "account_changed") return "refresh";
  if (status === 0 || status >= 500 || status === 429) return "retry";
  if (status === 404 || status === 410) return "unavailable";
  if (status === 400 || status === 422) return "edit";
  return "none";
}
